import React, { createContext, useState, useContext, ReactNode } from "react";
import ReactDOM from "react-dom";
const LoadingContext = createContext<LoadingContextType | undefined>(undefined);
interface LoadingContextType {
  show: (querySelector: string) => void;
  hide: () => void;
}

export const LoadingProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [visibleLoadingPanel, setvisibleLoadingPanel] = useState<
    boolean | null
  >(false);
  const [querySelector, setQuerySelector] = useState<string | null>(null);

  const createPanel = () => {
    const loadingPanel = (
      <div className="k-loading-mask">
        <span className="k-loading-text">Loading</span>
        <div className="k-loading-image" />
        <div className="k-loading-color" />
      </div>
    );
    if (typeof querySelector === "undefined" || querySelector === null) {
      return null;
    } else {
      const element = document && document.querySelector(querySelector);
      return element
        ? ReactDOM.createPortal(loadingPanel, element)
        : loadingPanel;
    }
  };

  const show = (querySelector: string) => {
    setvisibleLoadingPanel(true);
    setQuerySelector(querySelector);
  };
  const hide = () => {
    setvisibleLoadingPanel(false);
  };
  return (
    <LoadingContext.Provider value={{ show, hide }}>
      {children}
      {visibleLoadingPanel && createPanel()}
    </LoadingContext.Provider>
  );
};

export const useLoadingPanel = (): LoadingContextType => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoadingPanel must be used within a LoadingProvider");
  }
  return context;
};
